import React, { FC } from "react";
import moment from "moment";

// icon
import { ListIcon } from "../../../../../assets/svg/dashboard/ListIcon";

// style
import "../../../../../_jutemplate/assets/css/custom.css";

// componet
import { ListTitle } from "./ListTitle";
import { ListSubTitle } from "./ListSubTitle";
import { ListPrice } from "./ListPrice";

interface OrderListProps {
  onClick: () => void;
  customerName: string;
  time: string;
  price: number;
}

export const OrderList: FC<OrderListProps> = ({
  onClick: handleListClick,
  customerName,
  time,
  price,
}) => {
  const timeHavePassed = (getDate: string) => {
    const currentDate = moment();
    const userDate = moment(getDate);

    if (userDate.isAfter(currentDate)) {
      return "Some Thing Went Wrong";
    }

    const duration = moment.duration(currentDate.diff(userDate));

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    if (days > 0) {
      return `${days} ${days > 1 ? "days" : "day"} ago`;
    } else if (hours > 0) {
      return `${hours} ${hours > 1 ? "hours" : "hour"} ago`;
    } else if (minutes > 0) {
      return `${minutes} ${minutes > 1 ? "minutes" : "minute"} minutes ago`;
    } else {
      return `${seconds} ${seconds > 1 ? "seconds" : "second"} ago`;
    }
  };

  return (
    <li
      className="px-5 py-3 rounded-2 d-flex align-items-center gap-4 dashboard-list"
      onClick={handleListClick}
    >
        <ListIcon/>
        <div className="d-flex justify-content-between align-items-center flex-grow-1">
          <div className="d-flex flex-column gap-1">
            <ListTitle>{customerName}</ListTitle>
            <ListSubTitle>{timeHavePassed(time)}</ListSubTitle>
          </div>
          <ListPrice>{price}</ListPrice>
        </div>
      
    </li>
  );
};
